(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ongig-embed", [], factory);
	else if(typeof exports === 'object')
		exports["ongig-embed"] = factory();
	else
		root["ongig-embed"] = factory();
})(this, function() {
return 